import { BaseDriverDto } from '../../../shared/modules/base/dtos/base-driver.dto';
import { AccountListDto } from '../../accounts/dtos/account-list.dto';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Driver DTO
 */
export class ProtoDriverDto extends BaseDriverDto {
  account?: AccountListDto | null;
}
